import { createActions, createReducer } from "reduxsauce"
import * as Immutable from "seamless-immutable"
// import {
//     getCurrentLanguage
// } from '../../containers/LanguageSwitcher/config';
import AppConfig from "../../configs/AppConfig"
/* ------------- Types and Action Creators ------------- */
// const tag = '[LANGUAGE_SWITCHER_REDUX]'; // eslint-disable-line

const functionDefinitions = {
  changeLanguage: ["language"]
}

const { Types, Creators } = createActions(functionDefinitions)

export const LanguageSwitcherReduxTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const LanguageSwitcherInitState = {
  language: AppConfig.defaultLanguage
}

export const INITIAL_STATE = Immutable(LanguageSwitcherInitState)

/* ------------- Reducers ------------- */

export const changeLanguage = (state, action) => {
  // console.log("in redux chagne Lang");
  return state.merge({
    language: action.language
  })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CHANGE_LANGUAGE]: changeLanguage
})



// WEBPACK FOOTER //
// ./src/redux/languageSwitcher/languageSwitcherRedux.ts